export const WhyCanIEdit = {
  question: "Why can I edit someone else's V2MOM?",
  answer: "V2MOMs are collaborative and cross-functional. Oftentimes you'll be responsible for work on someone else's V2MOM and therefore maintaining an open editing policy means you can contribute to other V2MOMs easily."
}